// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconCloseInactive: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path
                fillRule="evenodd"
                d="M492,733 C493.104569,733 494,733.895431 494,735 L494,751 C494,752.104569 493.104569,753 492,753 L476,753 C474.895431,753 474,752.104569 474,751 L474,735 C474,733.895431 474.895431,733 476,733 L492,733 Z M486.842903,738.261653 L484,741.104556 L481.157097,738.261653 C480.808254,737.912782 480.242626,737.912782 479.893477,738.261653 L479.261653,738.893477 C478.912782,739.242348 478.912782,739.807949 479.261653,740.157097 L482.104556,743 L479.261653,745.842903 C478.912782,746.191746 478.912782,746.757374 479.261653,747.106523 L479.893477,747.738347 C480.242348,748.087218 480.808254,748.087218 481.157097,747.738347 L484,744.895444 L486.842903,747.738347 C487.191746,748.087218 487.757652,748.087218 488.106523,747.738347 L488.738347,747.106523 C489.087218,746.757652 489.087218,746.192051 488.738347,745.842903 L485.895444,743 L488.738347,740.157097 C489.087218,739.808254 489.087218,739.242626 488.738347,738.893477 L488.106523,738.261653 C487.757652,737.912782 487.192051,737.912782 486.842903,738.261653 Z"
                transform="translate(-474 -733)"
            />
        </svg>
    );
};

export default React.memo(IconCloseInactive);
